import { forwardRef } from "react";

const Column = ({ label, accent, title, text, children }) => (
  <div className="flex-1 min-w-0 rounded-[28px] p-9 flex flex-col gap-5" style={{ background: accent.bg, border: `1px solid ${accent.border}` }}>
    <p className="font-mono text-[13px] uppercase tracking-[0.22em]" style={{ color: accent.text }}>{label}</p>
    <p className="font-heading text-[26px] font-bold leading-tight text-white">{title}</p>
    <p className="text-[19px] leading-[1.6] text-[#e2e8f0] whitespace-pre-wrap break-words">{text}</p>
    {children}
  </div>
);

export const ShareCard = forwardRef(({ decision, userText, alterText }, ref) => (
  <div ref={ref} className="font-body" style={{ width: 1200, padding: 56, background: "#07080C", color: "#f8fafc" }}>
    <div className="flex items-center justify-between mb-10">
      <span className="font-heading font-extrabold text-[28px] tracking-tight">Other Self</span>
      <span className="font-mono text-[13px] uppercase tracking-[0.2em] text-[#64748b]">two timelines · one fork</span>
    </div>
    <p className="font-mono text-[14px] text-[#94a3b8] mb-8">
      <span className="text-[#a78bfa]">fork → </span>{decision}
    </p>
    <div className="flex gap-6 items-stretch">
      <Column
        label="The path you took"
        accent={{ bg: "#181D2D", border: "rgba(99,102,241,0.35)", text: "#818cf8" }}
        title="You"
        text={userText || "“Tell me about the life I didn't live.”"}
      />
      <Column
        label="The path you didn't"
        accent={{ bg: "#1D162C", border: "rgba(167,139,250,0.4)", text: "#a78bfa" }}
        title="Your other self"
        text={alterText}
      />
    </div>
  </div>
));
ShareCard.displayName = "ShareCard";
